module.exports = __webpack_public_path__ + "static/img/ban-9.ee524cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-9.png
// module id = FTpm
// module chunks = 0